import PenaltiesList from './PenaltiesList';

export default PenaltiesList;
